import React from "react";

function getActiveFromHash(value) {
  if (!window.location.hash.includes('=')) return null;

  const hash = window.location.hash.slice(1); // удаляем #
  const params = new URLSearchParams(hash);
  return params.get(value) || null;
}

function getActiveHash(props) {
  return getActiveFromHash(props.hashKey) || props.defaultValue;
}

class LocationHashObserver extends React.Component {

  static getInitial() {

  }

  constructor(props) {
    super(props);
    this.state = {
      activeValue: getActiveHash(props)
    };
    this.props.onValueChange(this.state.activeValue)
  }

  handleHashChange = () => {
    this.setState({
      activeValue: getActiveHash(this.props)
    }, () => {
      this.props.onValueChange(this.state.activeValue)
    });
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  render() {
    if (this.props.children) {
      return this.props.children(this.state.activeValue)
    } else {
      return this.props.children
    }
  }
}

export function createLocationObserver(rootProps) {
  return {
    getValue: () => getActiveHash(rootProps),
    Component: (props) => <LocationHashObserver {...rootProps} {...props}/>
  }
}

export default LocationHashObserver